module.exports = __webpack_public_path__ + "img/gy.a79f2659.svg";